      
/*
 * @Author: tracy.sun
 * @Date: 2023-03-29 14:32:38
 * @LastEditors: tracy.sun
 * @LastEditTime: 2023-09-14 18:12:06
 * @Description: 接口签名方法
 */
import CryptoJS from "crypto-js";
import md5 from "js-md5";

const appId = "6d5466889ea7c88cf1da2ddcb94b2a7c";
const secret = "b42ed4b5647928e0183a29629c3b4783";

// json对象按asc排序
export function sortAsc(jsonObj) {
  let arr = new Array();
  let num = 0;
  for (let i in jsonObj) {
    arr[num] = i;
    num++;
  }
  let sortArr = arr.sort();
  let sortObj = {};
  for (let i in sortArr) {
    sortObj[sortArr[i]] = jsonObj[sortArr[i]];
  }
  return sortObj;
}

// json对象转url参数拼接
export function jsonToUrlParam(json) {
  return Object.keys(json)
    .map(key => key + "=" + json[key])
    .join("&");
}

// AES加密并URL encode得到data
export function encryptByAES(data) {
  var encrypted = CryptoJS.AES.encrypt(data, secret);
  var ciphertext = encrypted.toString();
  return encodeURIComponent(ciphertext);
}

// 拼接secret后MD5得到sign
export function getSign(url, encryptData, timestamp) {
  const signUrl = "/api" + url + "?appId=" + appId + "&data=" + encryptData + "&timestamp=" + timestamp + "&" + secret;
  return md5(signUrl);
}

// 获取要给后端传的完整参数
export function getParams(params) {
  return encryptByAES(JSON.stringify(Array.isArray(params) ? params : sortAsc(params)));
}

// 按时区获取时间戳
export function getCurrentZoneTime(zone) {
  var timezone = zone; //目标时区
  var offset_GMT = new Date().getTimezoneOffset(); // 本地时间和格林威治的时间差，单位为分钟
  var nowDate = new Date().getTime(); // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
  var targetDate = new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000); //当前东八区的时间
  var current = targetDate.getTime(); //当前时区时间戳
  return current;
}

export function getHeader(url, encryptData) {
  const timestamp = getCurrentZoneTime(8);
  return {
    appId: appId,
    timestamp,
    sign: getSign(url, encryptData, timestamp)
  };
}

    